import axios from "@/repositories/client";
import default_role from "@/defaults/default-role";

axios.getRoles = (query, pagination, args) => {

  args.dropdown = args.dropdown || false;

  let options = {
    params: {
      search: query,
      skip: pagination.size * (pagination.page - 1),
      take: pagination.size
    }
  };

  return axios.get('athena/v1/roles', options)
    .then(response => {
      if(args.dropdown)
        return response.data.data.map(role => ({text: role.name, value: role.id}));

      return response.data;
    });
};

axios.getRole = (role) => {

  if (role === 'create')
    return new Promise((resolve => {
      resolve(_.cloneDeep(default_role));
    }));

  return axios.get(`athena/v1/roles/${role}`)
    .then(response => {
      return response.data.data;
    });
};

axios.saveRole = (role) => {
  const url = `athena/v1/roles` + (role.id ? `/${role.id}` : '');
  const verb = role.id ? 'PUT' : 'POST';

  return axios.request({method: verb, url: url, data: role})
    .then(response => {
      return response.data.data;
    });
};

axios.destroyRole = (role) => {
  return axios.delete(`athena/v1/roles/${role.id}`)
    .then(response => {
      return response.data;
    });
};

axios.getUserRoles = (user) => {
  const url = `athena/v1/user-roles`;
  return axios.request({method: 'GET', url: url, params: {user_id: user.user_id}})
    .then(response => {
      return response.data;
    });
};

axios.saveUserRoles = (user, roles) => {
  const url = `athena/v1/user-roles`;
  return axios.request({method: 'POST', url: url, data: {user_id: user, roles: roles}})
    .then(response => {
      return response.data;
    });
};

export default axios;